exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.log-tool-tip {\n  max-width: 60%;\n}\n", ""]);

// exports
